import api from 'app/actions/api';
import i18n from 'app/i18n';


export const IDENTIFIER_MODIFY_REQUEST = 'IDENTIFIER_MODIFY_REQUEST';
export const IDENTIFIER_MODIFY_SUCCESS = 'IDENTIFIER_MODIFY_SUCCESS';
export const IDENTIFIER_MODIFY_FAILURE = 'IDENTIFIER_MODIFY_FAILURE';

const identifierModifyRequest = id => ({
  type: IDENTIFIER_MODIFY_REQUEST,
  payload: id,
});

const identifierModifySuccess = data => ({
  type: IDENTIFIER_MODIFY_SUCCESS,
  payload: data,
});

const identifierModifyFailure = payload => ({
  type: IDENTIFIER_MODIFY_FAILURE,
  payload,
});


/**
* Блокировка идентификатора
*/
export const identifierBlock = (id, reason) => async (dispatch) => {
  dispatch(identifierModifyRequest(id));
  try {
    const { data: { result, ...identifiers } } = await api(
      'cabinet/identifiers/disable',
      'post',
      { data: { id, reason } }
    );
    dispatch(identifierModifySuccess(identifiers));
    return true;
  } catch (error) {
    dispatch(identifierModifyFailure({ ...error, err: i18n.t('app:request_identifier_block_failed') }));
    return false;
  }
};

/**
* Разблокировка идентификатора
*/
export const identifierUnblock = id => async (dispatch) => {
  dispatch(identifierModifyRequest(id));
  try {
    const { data: { result, ...identifiers } } = await api(
      'cabinet/identifiers/enable',
      'post',
      { data: { id } }
    );
    dispatch(identifierModifySuccess(identifiers));
    return true;
  } catch (error) {
    dispatch(identifierModifyFailure({ ...error, err: i18n.t('app:request_identifier_unblock_failed') }));
    return false;
  }
};
